import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Components from "../components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { doctorActions, patientActions, ehrActions } from "../core/actions";
import { CASERECORD, DISCHARGESUMMARY } from "../shared/constants";
import { makeStyles } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { helperServices } from "../shared/helper";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { format } from "date-fns";
import { Box } from "@mui/material";

// useDebounce hook
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

const DISCHARGE_SUMMARY_FIELDS = [
  "Final Diagnosis",
  "Chief Complaints",
  "Clinical Summary",
  "General physical examination",
  "Systemic Examination",
  "Clinical Investigations",
  "Course of treatment in hospital",
  "Condition on Discharge",
  "Advice on discharge",
  "Review in case of",
  "dischargedt",
];

function VedamaayuDischargeSummary(props) {
  const [patientEhrid, setPatientEhrId] = useState("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  // ── Refs ──────────────────────────────────────────────────────────────────
  const mySessionIdRef = useRef(null);
  const sessionReadyRef = useRef(false);
  const userHasEdited = useRef(false);
  const summaryLoadedRef = useRef(false);
  const selectedItemsDocRef = useRef([]);

  // ── State ─────────────────────────────────────────────────────────────────
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionOwner, setSessionOwner] = useState("");

  const [summary, setSummary] = useState({
    "Final Diagnosis": "",
    "Chief Complaints": "",
    "Clinical Summary": "",
    "General physical examination": "<p>Bp- 120/80 mm Hg</p><p>HR- 88 b/min</p><p>Spo2 -98% @ RA</p><p>RR-24 bpm</p>",
    "Systemic Examination": "<p>RS-B/L NVBS heard, no added sounds.</p><p>CVS-S1, S2 heard, no added sounds</p><p>P/A- soft and non-tender</p><p>CNS-no FND</p>",
    "Clinical Investigations": "<p>All report enclosed below</p>",
    "Course of treatment in hospital": "<p>Patient was brought with the above mentioned complaints</p>",
    "Condition on Discharge": "",
    "Advice on discharge": "",
    "Review in case of": "",
    "dischargedt": "",
  });

  const [dischargeId, setDischargeId] = useState();
  const [patientdetails, setPatientDetails] = useState({ name: "", visitDate: "" });
  const [dischrgeDetails, setDischrgeDetails] = useState({ id: "", patientId: "", dischargeDate: "" });
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [patientRevisitdetails, setPatientRevisitdetails] = useState("");
  const [dischargedt, setDischargedt] = useState("");
  const [loadsummary, setLoadSummary] = useState(false);
  const [formErrors, setFormErrors] = useState({
    "Final Diagnosis": "",
    "Clinical Summary": "",
    "Follow Up Date": "",
  });

  const useStyles = makeStyles((theme) => ({
    redAsterisk: { color: "red" },
    quillEditor: {
      height: "150px",
      marginBottom: "40px",
      "& .ql-container": { fontSize: "14px", fontFamily: "Arial, sans-serif" },
    },
  }));
  const classes = useStyles();

  const [details, setDetails] = useState({
    id: "", patientId: "", visitId: "", markForDel: "", groupname: "", preparedBy: "", approver: "",
  });
  const [doctorList, setDoctorList] = useState([]);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const dispatch = useDispatch();

  const [dischargePrint, setdischargePrint] = useState(false);
  const [fullName, setFullName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [selectedOptionDoc, setSelectedOptionDoc] = useState(null);
  const [selectedItemsDoc, setSelectedItemsDoc] = useState([]);
  const [doctors, setDoctors] = useState([]);

  const [targetIds, setTargetIds] = useState([]);
  const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
  const [dischargeDateFlag, setDischargeDateFlag] = useState(false);
  const [todayDate, setTodayDate] = useState(new Date());

  const [dischargeSummarytemplate, setDischargeSummarytemplate] = useState();
  const [labReportData, setLabReportData] = useState("");
  const [adviceRows, setAdviceRows] = useState([
    { medicine: "", dose: "", frequency: "", comment: "" },
    { medicine: "", dose: "", frequency: "", comment: "" },
    { medicine: "", dose: "", frequency: "", comment: "" },
  ]);
  const [doctorLoaded, setDoctorLoaded] = useState(false);
  const [autosaveStatus, setAutosaveStatus] = useState("idle");
  const [roomList, setRoomList] = useState([]);

  const debouncedSummary = useDebounce(summary, 5000);

  // ── Keep refs in sync ─────────────────────────────────────────────────────
  useEffect(() => { selectedItemsDocRef.current = selectedItemsDoc; }, [selectedItemsDoc]);

  // ── Session ID generation ─────────────────────────────────────────────────
  const waitForToken = (callback, delay = 200) => {
    const check = () => {
      const token = helperServices.getAuthorization();
      if (token) {
        const patientId = props.match.params.patientid;
        const visitId = props.match.params.visitid;

        if (!patientId || !visitId) {
          console.warn("patientId or visitId missing, skipping generateSessionId");
          return;
        }

        dispatch(
          patientActions.generateSessionId(patientId, visitId, (res) => {
            const sessionId = res?.procedure?.notes;
            if (sessionId && sessionId.includes("::")) {
              mySessionIdRef.current = sessionId;
              sessionReadyRef.current = true;
            } else {
              console.warn("Could not extract session ID:", res);
            }
          })
        );

        getDoctorList();
        getPatientProfile();
        document.getElementById("mainpage").style.paddingLeft = "0px";
        document.getElementById("sidebar").style.display = "none";
        getDischargeSummarytemplateById();
      } else {
        setTimeout(check, delay);
      }
    };
    check();
  };

  useEffect(() => {
    waitForToken();
  }, []);

  // ── Initial data fetches ──────────────────────────────────────────────────
  useEffect(() => {
    getDoctorList();
    getPatientProfile();
    document.getElementById("mainpage").style.paddingLeft = "0px";
    document.getElementById("sidebar").style.display = "none";
    getDischargeSummarytemplateById();
  }, []);

  // ── Fetch lab reports once EHR ID is available ────────────────────────────
  useEffect(() => {
    if (patientEhrid) {
      getPatientLabReports();
    }
  }, [patientEhrid]);

  // ── Sync advice rows from summary ─────────────────────────────────────────
  useEffect(() => {
    if (!summary) return;
    const list = getAdviceOnDischargeList(summary);
    if (Array.isArray(list) && list.length > 0) {
      setAdviceRows(list);
    }
  }, [summary]);

  // ── Load discharge summary once doctor list is ready — runs ONCE only ─────
  useEffect(() => {
    if (doctorLoaded && !summaryLoadedRef.current) {
      summaryLoadedRef.current = true;
      patientSummaryClick(doctorList);
    }
  }, [doctorLoaded]);

  // ── Match target IDs to doctor list ───────────────────────────────────────
  useEffect(() => {
    if (!targetIds.length) return;
    targetIds.forEach(({ id, vaId }) => {
      addIfMatched(doctorList, "doctor", id, setSelectedItemsDoc, vaId);
    });
  }, [targetIds, doctorList]);

  // ── Autosave on debounced summary change ──────────────────────────────────
  useEffect(() => {
    if (!debouncedSummary) return;
    if (!mySessionIdRef.current) return;
    if (!sessionReadyRef.current) return;
    if (!userHasEdited.current) return;

    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    dispatch(
      patientActions.validateSessionId(patientId, visitId, mySessionIdRef.current, (res) => {
        if (res && res.successMessages) {
          silentSave();
        } else {
          setAutosaveStatus("idle");
          setSessionExpired(true);
          const owner = res?.errorMessages
            ? (Array.isArray(res.errorMessages) ? res.errorMessages[0] : res.errorMessages)
            : "another user";
          setSessionOwner(owner);
        }
      })
    );
  }, [debouncedSummary]);

  // ── Silent autosave ───────────────────────────────────────────────────────
  const silentSave = () => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    var proList = [];
    const keys = DISCHARGE_SUMMARY_FIELDS;
    setAutosaveStatus("saving");
    for (let key of keys) {
      if (key === "session_id") continue;
      proList.push({
        claSS: key,
        notes: key === "Advice on discharge"
          ? JSON.stringify(getDischargeAdviceList())
          : summary[key],
        patientId,
        visitId,
      });
    }
    dispatch(patientActions.saveDischargeSummary(proList, () => {
      setAutosaveStatus("saved");
      setTimeout(() => setAutosaveStatus("idle"), 2000);
      refreshAssignmentIds();
    }));

    if (patientRevisitdetails) {
      dispatch(patientActions.followUpByDoctor(
        { patientId, lastvisitId: visitId, scheduleddate: patientRevisitdetails },
        () => { }
      ));
    }

    const buildAssignments = (items, type) =>
      (items || []).map((item) => ({
        targetid: item.personId,
        visitid: visitId,
        status: "open",
        type,
      }));

    const assignmentList = [
      ...buildAssignments(selectedItemsDocRef.current, "Doctor"),
    ];

    if (assignmentList.length > 0) {
      dispatch(patientActions.saveVisitAssignment(assignmentList, () => { }));
    }
  };

  // ── EHR template ─────────────────────────────────────────────────────────
  const getDischargeSummarytemplateById = () => {
    dispatch(
      ehrActions.getTemplateById("", "Discharge Summary", {}, (resCb) => {
        if (resCb) setDischargeSummarytemplate(resCb);
      })
    );
  };

  // ── Load discharge summary from API ──────────────────────────────────────
  const patientSummaryClick = (docList) => {
    details.patientId = props.match.params.patientid;
    details.visitId = props.match.params.visitid;
    details.groupname = DISCHARGESUMMARY;
    details.markForDel = false;

    dispatch(
      patientActions.getDischargeSummary(summary, details, (resCb) => {
        if (resCb) {
          const targetId = resCb?.vaList?.[0]?.targetid;
          if (targetId) {
            const matched = docList.find(
              (d) => String(d.personId) === String(targetId)
            );
            if (matched) {
              setSelectedDoctor((matched.displaytitle || "") + (matched.first_name || ""));
            }
          }

          if (resCb?.visit?.dischargeDate) {
            const dt = new Date(resCb.visit.dischargeDate);
            const formatted = format(dt, "yyyy-MM-dd'T'HH:mm");
            setDischargedt(formatted);
          }

          const ids = (resCb.vaList || [])
            .filter((v) => v?.targetid)
            .map((v) => ({ id: v.targetid, vaId: v.id, type: v.type }));
          setTargetIds(ids);

          if (resCb?.procedureList?.length > 0) {
            if (resCb?.visit) {
              const discharge = resCb.visit.dischargeDate;
              if (discharge) {
                const dt = new Date(discharge);
                const formattedDateTime =
                  `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}T${String(dt.getUTCHours()).padStart(2, "0")}:${String(dt.getUTCMinutes()).padStart(2, "0")}`;
                summary.dischargedt = formattedDateTime;
              }
            }

            if (resCb?.revisit) {
              setPatientRevisitdetails(resCb.revisit.scheduleddate);
            } else {
              const folDate = new Date();
              setPatientRevisitdetails(format(folDate.setDate(folDate.getDate() + 14), "yyyy-MM-dd"));
            }

            const filterList = resCb.procedureList.filter(
              (item) => item?.groupname === DISCHARGESUMMARY
            );
            var dischargeNotes = { ...summary };
            filterList.forEach((item) => {
              const resolvedKey = item?.claSS;
              if (resolvedKey in dischargeNotes) {
                dischargeNotes[resolvedKey] = item?.notes;
              }
            });
            setSummary({ ...dischargeNotes });
            userHasEdited.current = false;

          } else {
            details.groupname = CASERECORD;
            dispatch(
              patientActions.getDischargeSummary(summary, details, (resCb2) => {
                if (resCb2?.procedureList) {
                  if (resCb2?.revisit) {
                    setPatientRevisitdetails(resCb2.revisit.scheduleddate);
                  } else {
                    const folDate = new Date();
                    setPatientRevisitdetails(format(folDate.setDate(folDate.getDate() + 14), "yyyy-MM-dd"));
                  }

                  if (resCb2?.visit) {
                    const discharge = resCb2.visit.dischargeDate;
                    if (discharge) {
                      const dt = new Date(discharge);
                      const formattedDateTime =
                        `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}T${String(dt.getUTCHours()).padStart(2, "0")}:${String(dt.getUTCMinutes()).padStart(2, "0")}`;
                      setDischargedt(formattedDateTime);
                    } else {
                      const d = new Date();
                      setDischargedt(
                        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`
                      );
                    }
                  }

                  const filterList2 = resCb2.procedureList.filter(
                    (item) => item?.groupname === CASERECORD
                  );
                  var dischargeNotes2 = { ...summary };
                  filterList2.forEach((item) => {
                    const resolvedKey = item?.claSS;
                    if (resolvedKey in dischargeNotes2) {
                      dischargeNotes2[resolvedKey] = item?.notes;
                    }
                  });
                  setSummary({ ...dischargeNotes2 });
                  userHasEdited.current = false;
                }
              })
            );
          }
        }
      })
    );
  };

  const addIfMatched = (list = [], type, targetId, setState, vaId) => {
    if (!targetId || !type || !list.length) return;
    const matched = list.find(
      (item) =>
        String(item?.personId) === String(targetId) &&
        item?.type?.toLowerCase() === type.toLowerCase()
    );
    if (!matched) return;
    setState((prev) =>
      prev.some((p) => p.personId === matched.personId)
        ? prev
        : [...prev, { ...matched, vaId }]
    );
  };

  const refreshAssignmentIds = useCallback(() => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    const queryDetails = {
      patientId,
      visitId,
      groupname: DISCHARGESUMMARY,
      markForDel: false,
    };

    dispatch(
      patientActions.getDischargeSummaryForAutoSave({}, queryDetails, (resCb) => {
        if (!resCb?.vaList?.length) return;

        const ids = resCb.vaList
          .filter((v) => v?.targetid)
          .map((v) => ({ id: v.targetid, vaId: v.id, type: v.type }));

        setSelectedItemsDoc((prev) => {
          const updated = prev.map((item) => {
            const match = ids.find((x) => String(x.id) === String(item.personId));
            return match ? { ...item, vaId: match.vaId } : item;
          });
          selectedItemsDocRef.current = updated;
          return updated;
        });
      })
    );
  }, [dispatch, props.match.params.patientid, props.match.params.visitid]);

  const getAdviceOnDischargeList = (summaryData) => {
    const value = summaryData?.["Advice on discharge"];
    if (!value) return [];
    try {
      if (typeof value === "string") return JSON.parse(value);
    } catch (e) {
      console.error("Invalid Advice on discharge JSON", e);
    }
    return [];
  };

  const getPatientProfile = () => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    dispatch(
      patientActions.getPatientProfile(patientId, visitId, (resCb) => {
        if (resCb) {
          setPatientEhrId(resCb.ehrid);
          dispatch(patientActions.setPatientDetails(resCb));
          setFullName(`${resCb.fname} ${resCb.mname} ${resCb.lname}`);
          setRoomName(resCb.room?.roomName || "");
          setPhoneNum(resCb.phno);
          setRoomList(resCb.roomList || []);
          setPatientDetails({ resCb });
        }
      })
    );
  };

  const getDoctorList = () => {
    let docList = [];
    dispatch(
      doctorActions.getDoctorList({}, (resCb) => {
        if (resCb) {
          const doctorsArray = Array.isArray(resCb) ? resCb : [resCb];
          for (let doctor of doctorsArray) {
            if (doctor?.personId && doctor.type?.toLowerCase() === "doctor") {
              docList.push(doctor);
            }
          }
          setDoctorList([...docList]);
          setDoctorLoaded(true);
        }
      })
    );
  };

  const getPatientLabReports = () => {
    if (!patientEhrid) return;
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    dispatch(
      patientActions.getPatientProcedureInfo(patientId, visitId, "showAllVisits", (resCb) => {
        if (resCb?.patientresp?.procedureslist) {
          const labReports = resCb.patientresp.procedureslist.filter(
            (proc) => proc.subgroup?.includes("Lab_Report")
          );
          if (labReports.length > 0) {
            let allLabData = [];
            let processedCount = 0;
            labReports.forEach((report) => {
              if (report.compositionId) {
                dispatch(
                  ehrActions.getCompositionByVid({}, report.compositionId, patientEhrid, (compositionResponse) => {
                    if (compositionResponse) {
                      const extracted = extractLabTestValuesFromComposition(compositionResponse);
                      if (extracted) allLabData.push(extracted);
                    }
                    processedCount++;
                    if (processedCount === labReports.length) {
                      const combinedLabData = allLabData.join("\n---\n");
                      setSummary(prev => ({
                        ...prev,
                        "Clinical Investigations": combinedLabData || prev["Clinical Investigations"],
                      }));
                      setLabReportData(combinedLabData);
                    }
                  })
                );
              } else {
                processedCount++;
              }
            });
          }
        }
      })
    );
  };

  const extractLabTestValuesFromComposition = (composition) => {
    if (!composition?.content) return "";
    let outputLines = [];
    try {
      for (let content of composition.content) {
        if (!content.data?.events) continue;
        for (let event of content.data.events) {
          if (!event.data?.items) continue;
          let mainComment = "";
          let mainTestName = null;
          let subTests = [];
          for (let item of event.data.items) {
            if (item._type === "ELEMENT" && item.name?.value === "COMMENT") {
              if (item.value?.value) mainComment = item.value.value;
              break;
            }
          }
          for (let item of event.data.items) {
            if (item._type !== "CLUSTER") continue;
            let testName = "", resultValue = "", unit = "";
            if (item.items) {
              for (let subItem of item.items) {
                const fieldName = subItem.name?.value;
                if (fieldName === "Analyte name") testName = subItem.value?.value || "";
                if (fieldName === "Analyte result" && subItem.value) {
                  if (subItem.value.magnitude !== undefined) {
                    resultValue = subItem.value.magnitude;
                    unit = subItem.value.units || "";
                  } else if (subItem.value.value !== undefined) {
                    resultValue = subItem.value.value;
                  }
                }
              }
            }
            if (testName && resultValue === "") {
              if (mainTestName !== null) {
                let line = mainTestName;
                if (subTests.length > 0) line += `: ${subTests.join(", ")}`;
                if (mainComment) line += `, ${mainComment}`;
                outputLines.push(line);
                subTests = [];
              }
              mainTestName = testName;
            } else if (testName && resultValue !== "") {
              subTests.push(unit ? `${testName}:${resultValue} ${unit}` : `${testName}:${resultValue}`);
            }
          }
          if (mainTestName !== null || subTests.length > 0) {
            let line = mainTestName || "";
            if (subTests.length > 0) line = line ? `${line}: ${subTests.join(", ")}` : subTests.join(", ");
            if (mainComment) line += `, ${mainComment}`;
            if (line) outputLines.push(line);
          }
        }
      }
    } catch (e) {
      console.error("Lab formatting error", e);
    }
    return outputLines.join("\n");
  };

  const handleInputChange = (name, value) => {
    userHasEdited.current = true;
    var summarydata = summary;
    formErrors[name] = "";
    var note = details;
    summarydata[name] = value;
    note[name] = value;
    setSummary({ ...summarydata });
    setDetails({ ...note });
  };

  const handleInputChangeOnReactQuill = (name, value, source) => {
    if (source !== "user") return;
    userHasEdited.current = true;
    var summarydata = summary;
    formErrors[name] = "";
    var note = details;
    summarydata[name] = value;
    note[name] = value;
    setSummary({ ...summarydata });
    setDetails({ ...note });
  };

  const handlePrint = () => {
    const doctorsList = selectedItemsDoc.map((el) =>
      `${el.displaytitle} ${el.first_name || ""} ${el.last_name || ""}, Dep of ${el.department} (${el.qualification})`
    );
    setDoctors(doctorsList);
    setSummary((prev) => ({ ...prev, "Advice on discharge": getDischargeAdviceList() }));
    setdischargePrint(true);
  };

  const handleDischargePrint = () => setdischargePrint(false);

  const validateField = (fieldName, value) => {
    let fieldValidationErrors = formErrors;
    const textContent = (value != null ? String(value) : "").replace(/<[^>]*>/g, "");
    switch (fieldName) {
      case "Final Diagnosis":
        fieldValidationErrors["Final Diagnosis"] = textContent.length > 0 ? "" : "Please Enter Final Diagnosis";
        break;
      case "Clinical Summary":
        fieldValidationErrors["Clinical Summary"] =
          textContent.length === 0 ? "Please Enter Clinical Summary"
            : textContent.length > 800 ? "Clinical Summary exceed limit of 800 characters"
              : "";
        break;
      default: break;
    }
    setFormErrors(fieldValidationErrors);
  };

  const handleSubmit = async () => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    userHasEdited.current = false;

    if (!mySessionIdRef.current) {
      setServerRes({ error: "Session not initialized. Please refresh and try again." });
      setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
      return;
    }

    const sessionValid = await new Promise((resolve) => {
      dispatch(
        patientActions.validateSessionId(patientId, visitId, mySessionIdRef.current, (res) => {
          if (res?.successMessages) {
            resolve(true);
          } else {
            setSessionExpired(true);
            setSessionOwner(
              res?.errorMessages
                ? (Array.isArray(res.errorMessages) ? res.errorMessages[0] : res.errorMessages)
                : "another user"
            );
            resolve(false);
          }
        })
      );
    });

    if (!sessionValid) return;

    const curDate = format(new Date(), "yyyy-MM-dd");
    const fieldValidationErrors = { ...formErrors };
    fieldValidationErrors["Follow Up Date"] = patientRevisitdetails < curDate ? "Please Enter valid Follow up Date" : "";
    setFormErrors(fieldValidationErrors);
    Object.keys(summary).forEach((key) => validateField(key, summary[key]));
    validateForm();
  };

  const setMessageStrip = (e) => {
    const ServerResVal = { ...ServerRes };
    if (e.success) ServerResVal.success = e.success;
    else ServerResVal.error = e.error;
    setServerRes(ServerResVal);
    setTimeout(() => closeAlert(), 5000);
  };

  const validateForm = (silent = false) => {
    const formValid =
      formErrors["Final Diagnosis"] === "" &&
      formErrors["Clinical Summary"] === "" &&
      formErrors["Follow Up Date"] === "";

    for (let key in formErrors) {
      if (formErrors[key] !== "") {
        if (!silent) setMessageStrip({ error: "Please check there is a validation error in the discharge summary form" });
        return;
      }
    }

    if (formValid) {
      details.patientId = props.match.params.patientid;
      details.visitId = props.match.params.visitid;
      details.id = dischargeId;
      details.groupname = DISCHARGESUMMARY;
      var proList = [];
      var dischargeddt = [];
      const currentSummary = summary;
      const keys = DISCHARGE_SUMMARY_FIELDS;

      for (let key of keys) {
        if (key === "session_id") continue;
        proList.push({
          claSS: key,
          notes: key === "Advice on discharge"
            ? JSON.stringify(getDischargeAdviceList())
            : currentSummary[key],
          patientId: props.match.params.patientid,
          visitId: props.match.params.visitid,
        });
        if (key === "dischargedt") {
          dischargeddt.push({
            id: props.match.params.visitid,
            patientId: props.match.params.patientid,
            dischargeDate: currentSummary[key],
          });
          setDischrgeDetails(dischargeddt);
        }
      }

      const buildAssignments = (items, type) =>
        (items || []).map((item) => ({
          targetid: item.personId,
          visitid: props.match.params.visitid,
          status: "open",
          type,
        }));

      const assignmentList = [
        ...buildAssignments(selectedItemsDocRef.current, "Doctor"),
      ];

      dispatch(patientActions.saveDischargeSummary(proList, (resCb) => {
        if (resCb) {
          if (resCb.successMessages) {
            if (!silent) setServerRes({ success: "Discharge summary added successfully" });
            saveDischargeSummaryinEhr();
            refreshAssignmentIds();
          } else if (resCb.errorMessages) {
            if (!silent) setServerRes({ error: "Failed to add Discharge summary" });
          }
          if (!silent) setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
        }
      }));

      dispatch(patientActions.followUpByDoctor(
        { patientId: props.match.params.patientid, lastvisitId: props.match.params.visitid, scheduleddate: patientRevisitdetails },
        (resCb) => {
          if (resCb && !silent) {
            if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully" });
            else if (resCb.errorMessages) setServerRes({ error: "Failed to add Discharge summary" });
            setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
          }
        }
      ));

      if (assignmentList.length > 0) {
        dispatch(patientActions.saveVisitAssignment(assignmentList, (resCb) => {
          if (!resCb || silent) return;
          if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully.", error: "" });
          else if (resCb.errorMessages) setServerRes({ success: "", error: "Failed to add Discharge summary" });
          setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
        }));
      }

      if (!silent && dischargeddt.length > 0) {
        dispatch(patientActions.saveDischargeDate(dischargeddt, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully." });
            else setServerRes({ error: "Failed to add Discharge summary" });
            setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
          }
        }));
      }

      if (!silent) {
        setTimeout(() => closeAlert(), 3000);
      }
    } else {
      if (!silent) {
        setLoadSummary(!loadsummary);
        setMessageStrip({ error: "Please check there is a validation error in the discharge summary form" });
      }
    }
  };

  const saveDischargeSummaryinEhr = () => {
    if (!dischargeSummarytemplate?.composer) return;
    if (!dischargeSummarytemplate.content?.[0]?.items) return;

    dischargeSummarytemplate.content[0].items.map((item) => {
      const fieldname = item.name.value;
      let i = item?.data?.events?.[0]?.data?.items?.[0]?.value?.value;
      const fieldMap = {
        "Final Diagnosis": "Final Diagnosis",
        "Clinical Summary": "Clinical Summary",
        "Chief Complaints": "Chief Complaints",
        "Clinical Investigations": "Clinical Investigations",
      };
      if (fieldMap[fieldname]) i = summary[fieldMap[fieldname]] || i;
      else if (fieldname === "FollowUp Date") i = patientRevisitdetails || i;
      else if (fieldname === "Discharge Date") i = dischargedt || i;

      if (item?.data?.events?.[0]?.data?.items?.[0]?.value) {
        item.data.events[0].data.items[0].value.value = i;
        item.subject.name = selectedDoctor;
      }
    });

    dispatch(ehrActions.saveComposition(
      dischargeSummarytemplate,
      props.match.params.patientid,
      props.match.params.visitid,
      "Discharge Summary",
      patientEhrid,
      "Discharge summary saved in ehr",
      props.selectedProcedure ?? null,
      (resCb) => { if (resCb) console.log("EHR save response:", resCb); }
    ));
  };

  const closeAlert = () => setServerRes({ success: "", error: "" });

  const handleOptionSelect = (selectedDoctorId) => {
    const visitId = props.match.params.visitid;
    let newItem = null;

    doctorList.forEach((doc) => {
      if (doc.personId == selectedDoctorId && !selectedItemsDoc.some((i) => i.personId === doc.personId)) {
        newItem = doc;
        setSelectedItemsDoc((prev) => [...prev, doc]);
        setSelectedOptionDoc(selectedDoctorId);
      }
    });

    if (newItem) {
      dispatch(patientActions.saveVisitAssignment([{
        targetid: newItem.personId,
        visitid: visitId,
        status: "open",
        type: "Doctor",
      }], () => {
        refreshAssignmentIds();
      }));
    }
  };

  const handleRemoveItem = (item) => {
    const updated = selectedItemsDoc.filter((i) => i !== item);
    selectedItemsDocRef.current = updated;
    setSelectedItemsDoc(updated);
    userHasEdited.current = false;
    dispatch(patientActions.removeVisitAssignment([{
      id: item.vaId || null,
      targetid: item.personId,
      visitid: props.match.params.visitid,
      status: "close",
      type: "Doctor",
    }], () => { }));
  };

  const ChangeRevisitDate = (event) => {
    const val = event.target.value;
    setPatientRevisitdetails(val);
    const curDate = format(new Date(), "yyyy-MM-dd");
    setFormErrors((prev) => ({
      ...prev,
      "Follow Up Date": val < curDate ? "Please Enter valid Follow up Date" : "",
    }));

    if (val >= curDate) {
      dispatch(patientActions.followUpByDoctor(
        {
          patientId: props.match.params.patientid,
          lastvisitId: props.match.params.visitid,
          scheduleddate: val,
        },
        () => { }
      ));
    }
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...adviceRows];
    updatedRows[index][field] = value;
    setAdviceRows(updatedRows);
    handleInputChange("Advice on discharge", JSON.stringify(getDischargeAdviceList()));
  };

  const addRow = () => {
    setAdviceRows([...adviceRows, { medicine: "", dose: "", frequency: "", comment: "" }]);
  };

  const getDischargeAdviceList = () => {
    return adviceRows.filter(
      (row) => row.medicine.trim() !== "" || row.dose.trim() !== "" || row.frequency.trim() !== "" || row.comment.trim() !== ""
    );
  };

  const renderQuill = (label, fieldName, required = false) => (
    <div className="py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12" id="bgclr">
      <div style={{ marginBottom: "5px" }}>
        <label className="summary-label">
          {label}{" "}
          {required && <span className={`${classes.redAsterisk} MuiInputLabel-asterisk`}>*</span>}
        </label>
      </div>
      <ReactQuill
        theme="snow"
        value={summary[fieldName]}
        onChange={(content, delta, source) => {
          handleInputChangeOnReactQuill(fieldName, content, source);
        }}
        modules={modules}
        className={classes.quillEditor}
      />
      <div style={{ color: "#EC4147" }}>
        <span className="summary-label">{formErrors[fieldName]}</span>
      </div>
    </div>
  );

  return (
    <>
      {sessionExpired && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "white", padding: "30px", borderRadius: "8px", textAlign: "center" }}>
            <h5>Session Expired</h5>
            <p>This discharge summary is currently being edited by <strong>{sessionOwner}</strong>.<br />Please close and reopen to continue.</p>
            <button className="btn btn-danger" onClick={() => { window.open("", "_self"); window.close(); }}>Close</button>
          </div>
        </div>
      )}
      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton aria-label="close" color="inherit" size="small" onClick={closeAlert}><CloseIcon fontSize="inherit" /></IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton aria-label="close" color="inherit" size="small" onClick={closeAlert}><CloseIcon fontSize="inherit" /></IconButton>
        </Alert>
      )}

      <div className="bg-none nav-wrapper h-100 d-flex flex-column summary-view">

        {/* ── Autosave indicator ── */}
        {autosaveStatus !== "idle" && (
          <div style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 10000, display: "flex", alignItems: "center", gap: "8px", background: "#fff", padding: "10px 24px", borderRadius: "20px", boxShadow: "0 1px 6px rgba(0,0,0,0.10)", border: "1px solid #e0e0e0" }}>
            {autosaveStatus === "saving" && (
              <small style={{ color: "#1976d2", fontWeight: 500, fontSize: "30px" }}>⟳ Saving...</small>
            )}
            {autosaveStatus === "saved" && (
              <small style={{ color: "#2e7d32", fontWeight: 500, fontSize: "30px" }}>✓ Saved</small>
            )}
          </div>
        )}

        {/* ── Patient header ── */}
        <div className="pres-header" style={{ position: "sticky", top: 0, zIndex: 100, background: "white" }}>
          <div className="pres-layout-basic-info" style={{ position: "fixed", top: "48px", left: 0, right: 0, zIndex: 99, background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <div className="main-content-container container-fluid p-0">
              <div className="mb-12 col-md-12 hpcol bg menu-head">
                <div className="blog-comments__item d-flex cpointer p-2 menu-content">
                  <div className="blog-comments__content layout-head-content">
                    <div className="blog-comments__meta text-mutes d-flex img-name justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="text-secondary pname px-2" style={{ textTransform: "capitalize" }}>{fullName}</div>
                      </div>
                      <div className="d-flex flex-column">
                        {Array.isArray(roomList) && roomList.length > 0 && (
                          <small className="text-muted" style={{ fontWeight: 300, display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                            <i className="material-icons p-icon">bed</i>
                            {roomList.map((room) => room.floorId ? `Floor ${room.floorId} - ${room.roomName}` : room.roomName).join(", ")}
                          </small>
                        )}
                        {phoneNum && (
                          <small className="text-muted" style={{ fontWeight: 300, display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                            <i className="material-icons p-icon">phone</i>
                            <span>{phoneNum}</span>
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Main form ── */}
        <div className="d-flex h-100 px-3" id="discharge">
          <div className="px-2 w-100">
            <div className="w-100 service-container" style={{ overflowY: "auto" }}>
              <div className="w-100 flex-wrap flex-column px-3">
                <span>
                  <Box className="row service-form">

                    {/* ── Quill fields ── */}
                    {renderQuill("Diagnosis", "Final Diagnosis", true)}
                    {renderQuill("Chief Complaints", "Chief Complaints")}
                    {renderQuill("History of Present Illness", "Clinical Summary", true)}
                    {renderQuill("General Physical Examination", "General physical examination")}
                    {renderQuill("Systemic Examination", "Systemic Examination")}
                    {renderQuill("Investigation Done", "Clinical Investigations")}
                    {renderQuill("Course of Treatment in Hospital", "Course of treatment in hospital")}
                    {renderQuill("Condition on Discharge", "Condition on Discharge")}
                    {renderQuill("Review in case of", "Review in case of")}

                    {/* ── Treatment Advised (medicine table) ── */}
                    <div className="py-3 pl-0 col-12" id="bgclr">
                      <label className="summary-label mb-2">Treatment Advised</label>
                      {adviceRows.map((row, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "3fr 2fr 3fr 4fr" },
                            columnGap: 2,
                            rowGap: 1.5,
                            mb: 2,
                          }}
                        >
                          <TextField fullWidth size="small" label="Medicine Name" value={row.medicine} onChange={(e) => handleRowChange(index, "medicine", e.target.value)} />
                          <TextField fullWidth size="small" label="Dose" value={row.dose} onChange={(e) => handleRowChange(index, "dose", e.target.value)} />
                          <TextField fullWidth size="small" label="Frequency" value={row.frequency} onChange={(e) => handleRowChange(index, "frequency", e.target.value)} />
                          <TextField fullWidth size="small" label="Comment" value={row.comment} onChange={(e) => handleRowChange(index, "comment", e.target.value)} />
                        </Box>
                      ))}
                      <button type="button" className="btn btn-sm btn-outline-primary mt-2" onClick={addRow}>+ Add Medicine</button>
                    </div>

                    {/* ── Treating Doctor select ── */}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Treating Doctor</label>
                      <select className="form-control filterin Quantity" value={selectedOptionDoc || ""} onChange={(e) => handleOptionSelect(e.target.value)}>
                        <option disabled value="">---Select doctor---</option>
                        {doctorList.map((doctor) => (
                          <option key={doctor.personId} value={doctor.personId}>
                            {`${doctor.displaytitle || ""} ${doctor.first_name || ""} ${doctor.last_name || ""}, Dep of ${doctor.department || ""} (${doctor.qualification || ""})`}
                          </option>
                        ))}
                      </select>
                    </div>
                    {selectedItemsDoc.length > 0 && (
                      <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                        <label className="summary-label">Selected Doctors</label>
                        <div className="border" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "5px", background: "white" }}>
                          {selectedItemsDoc.map((item) => (
                            <div key={item.personId} className="d-flex p-1" style={{ justifyContent: "space-between", alignItems: "center" }}>
                              <label>{`${item.displaytitle || ""} ${item.first_name || ""} ${item.last_name || ""}, Dep of ${item.department || ""} (${item.qualification || ""})`}</label>
                              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveItem(item)}>Cancel</button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ── Dates ── */}
                    <div className="py-3 pl-0 col-lg-12">
                      <div className="row">
                        <div className="col-lg-6" style={{ width: "fit-content" }}>
                          <label className="service-lable">Follow Up Date</label>
                          <input
                            name="scheduleddate"
                            id="scheduleddate"
                            className="form-control filterin Quantity"
                            required
                            type="date"
                            readOnly={followUpDateFlag}
                            min={todayDate}
                            defaultValue={patientRevisitdetails}
                            onChange={ChangeRevisitDate}
                          />
                          <div style={{ color: "#EC4147" }}>
                            <span className="summary-label">{formErrors["Follow Up Date"]}</span>
                          </div>
                        </div>
                        <div className="col-lg-6" style={{ width: "fit-content" }}>
                          <label className="service-lable">Discharge Date</label>
                          <input
                            name="dischargedate"
                            id="dischargedate"
                            className="form-control filterin Quantity"
                            required
                            type="datetime-local"
                            readOnly={dischargeDateFlag}
                            min={todayDate}
                            value={summary.dischargedt || ""}
                            onChange={(e) => handleInputChange("dischargedt", e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ── Buttons ── */}
                    <div className="d-flex mx-1">
                      <button type="button" className="btn btn-primary" style={{ marginRight: "20px" }} onClick={handleSubmit}>Save</button>
                      <button type="button" className="ml-3 btn btn-primary" onClick={handlePrint}>Print</button>
                    </div>

                    {/* ── Print component ── */}
                    {dischargePrint && (
                      <div className="">
                        <Components.VedamaayuDischargePrint
                          parentCallBack={handleDischargePrint}
                          patientdetails={patientdetails}
                          revisitDetails={patientRevisitdetails}
                          doctorList={doctors}
                          summary={summary}
                        />
                      </div>
                    )}

                  </Box>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VedamaayuDischargeSummary;
